// Type-only: @aldebaran/prisma re-exports @prisma/client through a CommonJS
// `__exportStar`, whose named exports Rollup cannot resolve statically. Using
// the enum as a runtime value here fails the production patient build even
// though vitest and tsc resolve it fine. Prisma 6 emits InvitationType as a
// string union, so the literal keys below stay exhaustiveness-checked.
import type { InvitationType } from '@aldebaran/prisma';

export const WAITING_ROOM = 'salle_dattente';
export const CMGF_GAME = 'jeu_concours_cmgf';

export const INVITATION_TYPE_REFERRERS: Record<InvitationType, string> = {
  SMS: 'sms',
  EMAIL: 'email',
  DOCTOLIB: 'doctolib',
};

export const resolveInvitationReferrer = (
  explicitRef?: string | null,
  invitationType?: InvitationType | string | null,
): string | undefined => {
  const trimmedRef = explicitRef?.trim();
  if (trimmedRef) return trimmedRef;

  if (
    invitationType &&
    Object.prototype.hasOwnProperty.call(
      INVITATION_TYPE_REFERRERS,
      invitationType,
    )
  ) {
    return INVITATION_TYPE_REFERRERS[invitationType as InvitationType];
  }

  return undefined;
};
